import { unitsOfTime } from 'utils/unitsOfTime';
import { ReportInitialStateType, ViewOptionsRowsOrColumns } from './reports.types';

const calls = {
	call_ids_hash: '',
	additional_params: [],
};

const diffCalls = {
	calls_count: 0,
	calls_seconds: 0,
	percent_from_total_count: 0,

	client_talk_time: 0,
	client_talk_time_percentage: 0,

	operator_talk_time: 0,
	operator_talk_time_percentage: 0,

	silence_duration: 0,
	silence_duration_percentage: 0,

	tags_count: 0,
};

export const ViewOptionsGlobal = {
	show_table: true,
	show_chart: false,
	show_diff_report: false,
	show_zero_rows: true,
	show_zero_cols: true,
	show_zero_grouping_rows: true,
	show_zero_grouping_cols: true,
	show_row_calls_sum: true,
	show_col_calls_sum: true,
	show_row_all_calls_sum: false,
	show_col_all_calls_sum: false,
	show_row_calls_missed: false,
	show_col_calls_missed: false,
};

export const ViewOptionsRowsOrColumnsObj: ViewOptionsRowsOrColumns = {
	show_calls_count: true,
	show_minutes: false,
	show_percentage: false,
	show_operator_time: false,
	show_percentage_from_all_calls_row: false,
	show_percentage_from_all_calls_col: false,
	show_client_time: false,
	show_silence_time: false,
	show_operator_time_percentage: false,
	show_client_time_percentage: false,
	show_silence_time_percentage: false,
	show_call_dt: false,
	show_tags_count: false,
	show_deals: false,
	show_checklist_average: false,
	show_checklist_average_percent: false,
	show_client_phones: false,
	show_operator_phones: false,
	show_points: false,
	show_max_points: false,
	show_from_services: false,
	additional_params: [],
};

export const initialState: ReportInitialStateType = {
	allReports: [],
	currentSavedReport: { value: '', label: '' },
	isSavedReport: false,
	isReportByHash: false,
	isReportById: false,
	isReportCollapsed: false,
	isReportTooBig: false,
	callReport: {
		report: {
			cols: [
				{
					group_id: 0,
					col_name: '',
				},
			],
			cols_info: {
				any: {
					any: {
						col_all_calls: calls,
						col_missed_calls: calls,
						col_sum_calls: calls,
					},
				},
			},
			filtered_calls_count: 0,
			row_group_header: '',
			rows: [],
			total_calls_count: 0,

			values: {
				any: {
					col_groups: {
						any: {
							any: calls,
						},
					},
					row_info: {
						row_all_calls: calls,
						row_missed_calls: calls,
						row_sum_calls: calls,
					},
				},
			},
			summaries_of_summaries: {
				col_all_calls_sum: { call_ids_hash: '' },
				col_missed_calls_sum: { call_ids_hash: '' },
				col_sum_calls_sum: { call_ids_hash: '' },

				row_all_calls_sum: { call_ids_hash: '' },
				row_missed_calls_sum: { call_ids_hash: '' },
				row_sum_calls_sum: { call_ids_hash: '' },
			},
		},
		report_hash: '',

		report_parameters_hash: '',
	},

	reportWebSocket: null,

	diffReport: {
		cols_info: {
			any: {
				any: {
					col_all_calls: diffCalls,
					col_missed_calls: diffCalls,
					col_sum_calls: diffCalls,
				},
			},
		},
		rows: {
			any: {
				col_groups: {
					any: {
						any: diffCalls,
					},
				},
				row_info: {
					row_all_calls: diffCalls,
					row_missed_calls: diffCalls,
					row_sum_calls: diffCalls,
				},
			},
		},
	},
	diffReportIsLoaded: false,
	isDiffReportHide: false,
	activeReport: {
		report_name: '',
		report_type: 'calls',
		period: 'today',

		from_dt: unitsOfTime.today[0].utc(true).format(),
		to_dt: unitsOfTime.today[1].utc(true).format(),
		view_options: ViewOptionsGlobal,
		rows_group_by: [
			{
				group_by: '',
				value: null,
				view_options: ViewOptionsRowsOrColumnsObj,
			},
		],
		cols_group_by: [
			{
				group_by: '',
				view_options: ViewOptionsRowsOrColumnsObj,
			},
		],
		call_search_items: [],
	},
	additionalColumns: [],
	additionalRows: [],

	// сегодня
	date: unitsOfTime.today,
	selectors: {
		cols_groupings: [],
		groupings_by_time: [],
		report_types: [],
		rows_groupings: [],
		view_additional_params: [],
	},

	tagNames: [],
	tagNamesWithValues: [],
	tagRowValues: [],
	tagColumnValues: [],
	tagColumnsAddValues: [],

	tableRows: [],
	tableColumns: [],
	tableAllRows: [],

	isResetParameters: false,
	isLoading: false,
	reportLoadingIsStarted: false,
	loadingReport: {
		status: '',
		stage_name: '',
		stage_idx: 0,
		done: 0,
		total: 0,
		done_part: 0,
	},
	chartType: { value: '', label: '' },
	chartCheck: null,

	isValidTagList: false,
	isValidTagTitle: false,
	isValidSearchTitle: false,
};

export default initialState;
